import { render, staticRenderFns } from "./FacturaCrud.vue?vue&type=template&id=2cd0d794"
import script from "./FacturaCrud.vue?vue&type=script&lang=js"
export * from "./FacturaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports